<template>
  <div>
    <div v-if="data" class="roundbox">
      <tab :tabs="tabs" v-model="tab" ref="tabs"></tab>

      <fieldset id="tab-general" v-show="tab == 'general'">
        <div class="rbcontent">
          <table class="table table-borderless table-sm ozet">
            <tbody>
              <tr>
                <td style="width: 10px">İşin Adı</td>
                <td style="width: 1px">:</td>
                <td style="font-weight: bold">
                  {{ data.Title }}
                </td>
              </tr>

              <tr>
                <td style="width: 10px">Takip No</td>
                <td style="width: 1px">:</td>
                <td style="font-weight: bold">
                  {{ data.TrackingNo | trackingNo }}
                </td>
              </tr>
              <tr v-show="data.Description">
                <td>Açıklama</td>
                <td>:</td>
                <td>{{ data.Description }}</td>
              </tr>
              <tr v-if="data.CirculationProfileSchema">
                <td>Dolaşım Profili</td>
                <td>:</td>
                <td>{{ data.CirculationProfileSchema.Name }}</td>
              </tr>
              <tr v-show="data.TargetDate">
                <td>Hedeflenen Bitiş</td>
                <td>:</td>
                <td>{{ data.TargetDate | date }}</td>
              </tr>
              <tr>
                <td>Durum</td>
                <td>:</td>
                <td>
                  <label class="badge" :class="'bg-' + jobStatusClass">{{
                    jobStatusLabel
                  }}</label>
                </td>
              </tr>
              <tr>
                <td>Türü</td>
                <td>:</td>
                <td>
                  <job-document-type :documentType="data.DocumentType" />
                  <span v-show="data.Amount">
                    —
                    <span class="text-muted"
                      >{{ data.Amount | money }} {{ data.Currency }}</span
                    >
                  </span>
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold; color: #000">Dosyalar</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style="padding: 0" colspan="3">
                  <!-- @click="downloadDocument(d)" -->
                  <div
                    v-for="d in data.Documents"
                    :key="d.id"
                    class="documentContainer"
                  >
                  <file-download-link :isActive="userActions.CanDownload" :isOnlineView="onlineViewEnabled" :document="d" @download="downloadDocument" @preview="showFilePreview" :isDocumentFormat="isFilePattern"></file-download-link>
                    <div style="float: right;">
                      {{ d.UnsignedFile.Size | prettyBytes }}
                    </div>
                    <!-- <a class="">{{ d.UnsignedFile.FileName }}</a> -->
                  </div>
                </td>
              </tr>
              <tr v-show="data.Attachments && data.Attachments.length > 0">
                <td style="font-weight: bold; color: #000">Ekler</td>
                <td></td>
                <td style="padding: 0"></td>
              </tr>
              <tr>
                <td style="padding: 0" colspan="3">
                  <div
                    v-for="d in data.Attachments"
                    :key="d.id"
                    class="documentContainer"
                  >
                  <file-download-link :isActive="userActions.CanDownload" :isOnlineView="onlineViewEnabled" :document="d" @download="downloadAttachment" @preview="showAttachmentPreview" :isDocumentFormat="isFilePattern"></file-download-link>
                    <div style="float: right">{{ d.Size | prettyBytes }}</div>
                    <!-- <a class="">{{ d.FileName }}</a> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </fieldset>
      <fieldset id="tab-flowsummary" v-show="tab == 'flowsummary'">
        <div class="col rbcontent">
          <table class="table table-borderless table-hover table-flow-summary">
            <tbody>
              <!-- <tr
                  v-for="s in data.FlowSummary"
                  :key="s.Date"
                  style="border-bottom:1px solid rgba(0,0,0,.04)"
                >
                  <td
                    style="width:1px; vertical-align:middle; padding-left:2px"
                  >
                    <svg
                      v-if="s.Tense == 'Past'"
                      width="1.7em"
                      height="1.7em"
                      viewBox="0 0 16 16"
                      class="text-success bi bi-check2-circle"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M15.354 2.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L8 9.293l6.646-6.647a.5.5 0 0 1 .708 0z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M8 2.5A5.5 5.5 0 1 0 13.5 8a.5.5 0 0 1 1 0 6.5 6.5 0 1 1-3.25-5.63.5.5 0 1 1-.5.865A5.472 5.472 0 0 0 8 2.5z"
                      />
                    </svg>
                    <svg
                      v-if="s.Tense == 'Present'"
                      width="1.7em"
                      height="1.7em"
                      viewBox="0 0 16 16"
                      class="text-danger bi bi-forward"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M9.502 5.513a.144.144 0 0 0-.202.134V6.65a.5.5 0 0 1-.5.5H2.5v2.9h6.3a.5.5 0 0 1 .5.5v1.003c0 .108.11.176.202.134l3.984-2.933a.51.51 0 0 1 .042-.028.147.147 0 0 0 0-.252.51.51 0 0 1-.042-.028L9.502 5.513zM8.3 5.647a1.144 1.144 0 0 1 1.767-.96l3.994 2.94a1.147 1.147 0 0 1 0 1.946l-3.994 2.94a1.144 1.144 0 0 1-1.767-.96v-.503H2a.5.5 0 0 1-.5-.5v-3.9a.5.5 0 0 1 .5-.5h6.3v-.503z"
                      />
                    </svg>
                    <svg
                      v-if="s.Tense == 'Future'"
                      width="1.6em"
                      height="1.6em"
                      viewBox="0 0 16 16"
                      class="text-muted bi bi-hourglass-split"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H9v1.07A7.001 7.001 0 0 1 8 16 7 7 0 0 1 7 2.07V1h-.5A.5.5 0 0 1 6 .5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3zm0 2.1a.5.5 0 0 1 .5.5V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 0 1 .5-.5z"
                      />
                    </svg>
                  </td>
                  <td>
                    <div class="" style="display: flex;">
                      <div v-if="s.TargetSystem">
                        <span class="text-muted">Hedef Sistem:</span>
                        {{ s.TargetSystem.Name }}
                      </div>
                      <div>
                        <span v-for="(u, index) in s.Relateds" :key="u.Id">
                          <span v-if="index > 0">,</span>

                          <img
                            :src="u.ProfilePictureUrl"
                            class="flow-picture"
                          />
                          <b style="font-size:11px;">{{ u.Name }}</b>
                        </span>
                      </div>
                      <div
                        style="font-size: 0.9rem; padding-top: 0; margin-left: 5px;"
                      >
                        {{ s.Description }}
                      </div>
                      <small
                        class="text-muted"
                        style="margin-top: 3px; margin-left: 20px;"
                        v-show="s.Note"
                      >
                        {{ s.Note }}
                      </small>
                    </div>
                    <div
                      class="float-right text-muted"
                      style="position: relative;"
                    >
                      <small>{{ s.Date | datetime }}</small>
                    </div>
                  </td>
                </tr> -->

              <tr
                v-for="s in data.FlowSummary"
                :key="s.Date"
                style="border-bottom: 1px solid rgba(0, 0, 0, 0.04)"
              >
                <td
                  style="
                    width: 1px;
                    vertical-align: top;
                    text-align: center;
                    padding-left: 12px;
                    opacity: 0.7;
                  "
                >
                  <svg
                    v-if="s.Tense == 'Past'"
                    title="İşlem tamamlandı"
                    width="1.7em"
                    height="1.7em"
                    fill="currentColor"
                    class="bi bi-arrow-right-circle"
                    viewBox="0 0 16 16"
                    :class="[
                      s.Type == 'Decline' ? 'text-danger' : 'text-success',
                      s.Type == 'Cancel' ? 'text-warning' : 'text-success',
                    ]"
                  >
                    <path
                      d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                    />
                  </svg>

                  <svg
                    v-if="s.Tense == 'Present'"
                    title="Bu işlem bekleniyor"
                    width="1.7em"
                    height="1.7em"
                    fill="currentColor"
                    class="bi bi-arrow-right-circle-fill text-primary"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
                    />
                  </svg>

                  <svg
                    v-if="s.Tense == 'Future'"
                    title="İşlem henüz gerçekleşmedi"
                    width="1.6em"
                    height="1.6em"
                    viewBox="0 0 16 16"
                    class="text-muted bi bi-hourglass-split"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H9v1.07A7.001 7.001 0 0 1 8 16 7 7 0 0 1 7 2.07V1h-.5A.5.5 0 0 1 6 .5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3zm0 2.1a.5.5 0 0 1 .5.5V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 0 1 .5-.5z"
                    />
                  </svg>

                  <svg
                    v-if="s.Tense == 'Canceled'"
                    title="İşlem iptal edildi"
                    width="1.6em"
                    height="1.6em"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    class="text-warning bi bi-dash-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"
                    />
                  </svg>
                </td>
                <td>
                  <div class="row">
                  <div class="">
                    <div v-if="s.TargetSystem">
                      <span class="text-muted">Alıcı:</span>
                      {{ s.TargetSystem.Name }}
                    </div>
                    <div>
                      <span v-for="(u, index) in s.Relateds" :key="u.Id">
                        <span v-if="index > 0">,</span>
                        <img v-if="u.Type == 'SignGroup'" src="../assets/sign-group.png" class="flow-picture" />
                        <img v-else
                          :src="
                            getDefaultProfilePictureIfNull(u.ProfilePictureUrl)
                          "
                          class="flow-picture"
                        />
                        <b>{{ u.Name }}</b>
                        <span v-if="u.Type == 'External'">
                          (Dış Kullanıcı)
                        </span><br>
                        <span style="font-size: 0.9rem; padding-top: 3px;" v-if="u.Type == 'SignGroup'">
                                (İmza Grubu) 
                        </span>
                        <span v-if="u.GroupName" style="font-size: 0.9rem;">(İmza Grubu - {{ u.GroupName }})</span>
                      </span>
                    </div>
                    <div style="font-size: 0.9rem; padding-top: 3px">
                      <span v-if="s.Tense == 'Canceled'">
                        <span style="text-decoration: line-through">{{
                          s.Description
                        }}</span>
                      </span>
                      <span v-else>
                        <icon-dash-circle
                          v-if="s.Type == 'Cancel'"
                          class="text-warning"
                        />
                        <icon-x-circle
                          v-if="s.Type == 'Decline'"
                          class="text-danger"
                        />
                        <icon-circle
                          v-if="s.Type == 'UndoCancel'"
                          class="text-primary"
                        />
                        {{ s.Description }}
                      </span>                      
                      <span
                        class="fixed-right text-muted"
                      >
                        <small>{{ s.Date | datetime }}</small>
                      </span>
                    </div>
                    <small class="text-muted" v-show="s.Note">
                      {{ s.Note }}
                    </small>
                  </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </fieldset>
      <div class="commands">
        <div class="row">
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-danger"
              @click="$emit('decline')"
              v-if="userActions.CanDecline"
            >
              Reddet
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="approve"
              v-if="userActions.CanApprove"
            >
              Onayla
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="initial"
              v-if="userActions.CanInitial"
            >
              Parafla
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="$emit('sign')"
              v-if="userActions.CanSign"
            >
              Mobil İmzala
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="note note-warning">
        <h3>Bilgi</h3>
        <p>Kayıt bulunamadı.</p>
      </div>
    </div>
    <div
      v-if="isOTPPanelVisible"
      class="modal fade show"
      style="display: block; background-color: rgba(0, 0, 0, 0.4);"
      tabindex="-1"
      role="dialog"
      >
        <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
              <div class="modal-header">
              <h5 class="modal-title">SMS Kimlik Doğrulama</h5>
              <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  data-dismiss="modal"
                  :disabled="loading"
                  :aria-label="'Kapat'"
                  @click="isOTPPanelVisible = false"
              >
                  <span aria-hidden="true">&times;</span>
              </button>
              </div>
              <div class="modal-body">
              <div v-if="this.validationResult">
                  <form>
                  <fieldset :disabled="loading">
                      <p v-if="this.validationResult.Mobile">
                      <b>{{ this.validationResult.Mobile }}</b> numaralı telefonunuza doğrulama kodu SMS
                  olarak gönderilmiştir ve kısa süre içerisinde ulaşacaktır.
                      </p>
                      <p v-else>
                        Telefonunuza doğrulama kodu SMS olarak gönderilmiştir ve kısa süre içerisinde ulaşacaktır.
                      </p>

                      <div class="form-group">
                      <label>Lütfen telefonunuza gelen doğrulama kodunu giriniz:</label>
                      <input
                          v-model="approveForm.OTP"
                          type="text"
                          class="form-control text-center"
                          aria-describedby="validationCodeHelp"
                          required
                      />
                      </div>
                      <div v-if="errorMessage" class="text-danger">
                        Hata : {{ errorMessage }}
                      </div>
                      <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
                          <img src="../assets/loading_blue.gif" />
                          {{ processingMessage }}
                      </div>
                  </fieldset>
                  </form>
              </div>
              <div v-else>
                  <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
                      <img src="../assets/loading_blue.gif" />                    
                      Yükleniyor...
                  </div>
              </div>        
              </div>
              <div class="modal-footer">
              <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="isOTPPanelVisible = false"
              >
              Kapat
              </button>
              <button
                  class="btn btn-success"
                  style="width: 100px"
                  :disabled="loading"
                  @click="validate"
              >
              Doğrula
              </button>
              </div>
          </div>
        </div>
    </div>
    <file-preview v-if="fileDetail" :file="fileDetail" :viewer="viewerType" :isOnlineView="onlineViewEnabled" @close="fileDetail=null;"></file-preview>
    <MultipleViewer v-if="multipleFiles" :clickedFileId="clickedFileId" :viewer-type="viewerType" :files="multipleFiles" @closeMultipleFilePreview="multipleFiles = null"></MultipleViewer>
  </div>
</template>
<script>
import axios from "axios";
import JobDocumentType from "../components/JobDocumentType.vue";
import tab from "../components/Tab.vue";
import FileDownloadLink from "./FileDownloadLink.vue";
import FilePreview from "./FilePreview.vue";

import iconDashCircle from '../components/Icons/dash-circle.svg'
import iconXCircle from '../components/Icons/x-circle.svg'
import iconCircle from '../components/Icons/circle.svg'
import MultipleViewer from "./MultipleViewer.vue";

export default {
  components: {
    JobDocumentType,
    tab,
    iconDashCircle,
    iconXCircle,
    iconCircle,
    FileDownloadLink,
    FilePreview,
    MultipleViewer
  },
  data() {
    return {
      documentInfo: null,
      fileDetail: null,
      onlineViewEnabled: true,
      isOTPPanelVisible: false,
      validationResult: {},
      errorMessage: null,
      processingMessage: null,
      approveForm: {},
      tab: "general",
      tabs: [
        { key: "general", text: "İş Bilgileri" },
        { key: "flowsummary", text: "Dolaşım Adımları" },
      ],
      multipleFiles: null,
      clickedFileId: null, 
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    userActions: {
      type: Object,
      required: true,
    },
  },
  created(){
    this.getOnlineViewPermission()
        .then(x => {
          console.log(x)
            this.onlineViewEnabled = x;
        }).catch(x => {
            console.warn("getOnlineViewPermission alınamadı:", x);
            this.onlineViewEnabled = true;
        });
  },
  computed: {
    jobStatusLabel() {
      if (!this.data || !this.data.State) return null;
      return this.$izonay.jobStatus[this.data.State]?.text;
    },
    jobStatusClass() {
      if (!this.data || !this.data.State) return null;

      return this.$izonay.jobStatus[this.data.State]?.css;
    },
    isFilePattern(){
        var filePatternFound = true;
        this.data.Finalizers.forEach(finalizer => {
            if(finalizer.TargetSystem.DocumentFormat == null || finalizer.TargetSystem.DocumentFormat == 'None'){
                filePatternFound = false;
            }
        });
        return filePatternFound;
    }
  },
  methods: {
    showFilePreview(document, type, isFormatted,isDropdownClick) {
      if(document.SignedFile && type == 'pdf' && !isDropdownClick){
          document.IsSigned = true;
      }
      if(isDropdownClick){
          document.IsSigned = false;
      }
      this.viewerType = type;
      if(this.data.Documents.length > 1){
        this.clickedFileId = document.Id
        this.multipleFiles = this.data.Documents
        this.multipleFiles.map(x => {
            x.UnsignedFile.EntityType = 'job';
            x.UnsignedFile.EntityId =  this.data.Id
            x.IsAttachment = false
            if(isFormatted)
                x.IsFormatted = true;
            else
                x.IsFormatted = false;
        } )
      }else{
        this.fileDetail = document;
        this.fileDetail.EntityId = this.data.Id;
        if(isFormatted)
            this.fileDetail.IsFormatted = true;
        else
            this.fileDetail.IsFormatted = false;
      }
    },
    showAttachmentPreview(document, type, isFormatted) {
            this.viewerType = type;
            if(this.data.Attachments.length > 1){
                this.clickedFileId = document.Id
                this.multipleFiles = this.data.Attachments
                this.multipleFiles.map(x => {
                    x.EntityType = 'job';
                    x.EntityId =  this.data.Id
                    x.IsAttachment = true
                    if(isFormatted)
                        x.IsFormatted = true;
                    else
                        x.IsFormatted = false;
                } )
            }else{
                this.fileDetail = document;
                this.fileDetail.EntityId = this.data.Id;
                if(isFormatted)
                    this.fileDetail.IsFormatted = true;
                else
                    this.fileDetail.IsFormatted = false;
            }
        },
    downloadDocument(document,menuKey) {
      // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
     
      return axios
        .post(`/job/createDocumentUrl/`, {
          EntityId: this.data.Id,
          DocumentId: document.Id,
          IsSigned: menuKey == 'downloadSigned' ? true : false,
          IsFormatted: menuKey == 'downloadFormatted' ? true : false,
        })
        .then((x) => {
          console.log("createDocumentUrl Result:", x.data);
          this.documentInfo = {
            FileName: document.UnsignedFile.FileName,
            Size: document.UnsignedFile.Size,
            Url: x.data.Data.Url,
          };
          if(this.isIOS()){
            window.location = x.data.Data.Url
          }else {
            window.open(x.data.Data.Url);
          }
          
          
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    downloadAttachment(attachment) {
      // İndirilecek ek dosya için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
      return axios
        .post(`/job/createAttachmentUrl/`, {
          EntityId: this.data.Id,
          AttachmentId: attachment.Id,
        })
        .then((x) => {
          console.log("createAttachmentUrl Result:", x.data);
          attachment.Url = x.data.Data.Url;

          this.documentInfo = {
            FileName: attachment.FileName,
            Size: attachment.Size,
            Url: x.data.Data.Url,
          };

          this.documentInfo = attachment;
          console.log(JSON.stringify(this.documentInfo));
          if(this.isIOS()){
            window.location = x.data.Data.Url
          }else {
            window.open(x.data.Data.Url);
          }
        })
        .catch((x) => {
          switch (x.response.status) {
            case 404:
              this.$izonayAlert("Kayıt bulunamadı.");
              break;
            default:
              this.errorMessage = "İşlem gerçekleştirilemedi: " + x;
              break;
          }
          this.loading = false;
        });
    },
    approve() {
      this.loading = true;
      var url = `/job/approve/`;
      return axios
        .post(url, { JobId: this.$route.params.id, description: "" })
        .then((x) => {
          console.log("POST Result:", x.data);
          if(x.data.Data.SessionId){
            this.validationResult = x.data.Data;
            this.isOTPPanelVisible = true
            console.log(this.validationResult)
          }
          else if (x.data.Success) {
            this.data = x.data.Data.Job;
            this.userActions = x.data.Data.UserActions;
            this.$izonayAlert("Belgeleriniz başarıyla onaylanmıştır.", "success");
            this.view = "detail";
          } else {
            this.$izonayAlert(x.data.ErrorMessages);
          }

          this.loading = false;
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    initial() {
      this.loading = true;
      var url = `/job/initial/`;
      return axios
        .post(url, { JobId: this.$route.params.id, description: "" })
        .then((x) => {
          console.log("POST Result:", x.data);
          if (x.data.Success) {
            this.data = x.data.Data.Job;
            this.userActions = x.data.Data.UserActions;
              this.$izonayAlert("Belgeleriniz başarıyla paraflanmıştır.", "success");
            this.view = "detail";
          } else {
            this.$izonayAlert(x.data.ErrorMessages);
          }

          this.loading = false;
        })
        .catch((x) => window.processErrorResponse(x, this));
    },
    validate(){
        this.loading = true;
        this.processingMessage = "Doğrulanıyor..."
        var url = `/job/ApproveOTPJob/`;
        axios.post(url, {SessionId: this.validationResult.SessionId , OTP: this.approveForm.OTP, JobId: this.$route.params.id, description: this.description ?? "" })
        .then(x => {
            if(x.data.Success){
                console.log("Başarılı")
                this.data = x.data.Data.Job;
                this.userActions = x.data.Data.UserActions;
                this.description = null;
                this.$izonayAlert("Belgeleriniz başarıyla onaylanmıştır. İşleminiz zaman damgalı loglanmıştır.", "success");
                this.$router.push({ name:'Job' });
            } else{
                this.$izonayAlert(x.data.ErrorMessages);
            }
        this.loading = false;
        this.isOTPPanelVisible = false;
        })
        .catch(x => window.processErrorResponse(x, this));
    },
  },
};
</script>
<style scoped>
.roundbox {
  background: #fff;
  border-radius: 8px;
  /* box-shadow: 0px 2px 1px 1px #DDDD; */
  padding-top: 1px;
}

.roundbox .rbcontent {
  padding: 20px 5px 20px 5px;
}

.roundbox .rbcontent.head {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 14px 30px 24px 30px;
}

.roundbox .rbcontent.form {
  background-color: #f7f7f7;
}

.roundbox .rbcontent.head h2 {
  position: relative;
  top: 8px;
  display: inline;
}

.roundbox .rbcontent.footer {
  padding: 14px 30px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.table-flow-summary td,
.table-flow-summary th {
  padding: 0.75rem;
  vertical-align: top;
}
.col-left {
  display: flow-root;
  width: 95%;
}
.flow-picture {
  width: 1.4em;
  height: 1.4em;
  vertical-align: middle;
  margin-right: 4px;
  border-radius: 1.2em;
}
.nav.nav-pills li a.active {
  background: none;
  border-bottom: 4px solid #35495e !important;
  color: #35495e;
}

.nav.nav-pills a {
  color: #808080 !important;
  border-radius: 0;
  background: #fff;
  border-bottom: 4px solid #fff;
  font-size: 18px;
  text-decoration: none !important;
}

.nav.nav-pills a:hover {
  background: none;
  color: #35495e;
}

a {
  color: #0d6efd !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}
.note-warning {
  border-color: #f0ad4e;
  background: #fcf8e3;
}

.note {
  margin: 0 0 20px 0;
  padding: 15px 30px 15px 15px;
  border-left: 3px solid #e5e5e5;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}
.note h1,
.note h2,
.note h3,
.note h4 {
  margin-top: 0;
}
.note p:last-child {
  margin-bottom: 0;
}
p {
  margin: 0 0 10px;
}

.fixed-right{
  position: absolute;
  right: 1rem;
}
.documentContainer{
  z-index: 1 !important;
  opacity: 1 !important;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
</style>
